import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            companyId: '',
            filter: '',
            fromDate: '',
            toDate: '',
            companyName: '',
            isDateError : null,
            openAddOrder: false,
            dates: [],
            schedules: [],
            schedulesForDoc: new Map(),
            types: [],
        }
    },
    computed: {
        filteredUsers() {
            return this.schedules.filter(item => {
                return  this.checkNull(item.username).toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
            })
        }
    },
    methods: {
        getReport: getReport,
        round: round,
        roundWhole: roundWhole,
        generateExcelFile: generateExcelFile,
        generateOrderFromSchedule: generateOrderFromSchedule,
        sumOrdersPrice: sumOrdersPrice,
        hasScheduleByDate: hasScheduleByDate,
        generateDates: generateDates,
        formatDate: formatDate,
        getVoucherStyle: getVoucherStyle,
        getVouchers: getVouchers,
        calculateHours: calculateHours,
        calculateHoursNew: calculateHoursNew,
        displayHoursAndMinutes: displayHoursAndMinutes,
        changedDateFrom: changedDateFrom,
        changedDateTo: changedDateTo,
        generatePDFFile: generatePDFFile,
        convertStringShiftToDouble: convertStringShiftToDouble,
        recalculateVouchers: recalculateVouchers,
        recalculateVouchersNew: recalculateVouchersNew,
        keymonitor: keymonitor,
        checkNull: checkNull,
        openAddUserModal: openAddUserModal,
        mergeVouchers: mergeVouchers,
        compareByProfit(a, b) {
            let aProfit = a.profit == null ? 0 : a.profit;
            let bProfit = b.profit == null ? 0 : b.profit;

            if (aProfit > bProfit)
                return -1;
            if (bProfit > aProfit)
                return 1;
            return 0;
        },

        compareByTime(a, b) {
            let aTime =  a.startShift;
            let bTime = b.startShift;
            if(aTime === bTime){
                return a.name.localeCompare(b.name)
            }
            if (aTime < bTime)
                return -1;
            if (aTime > bTime)
                return 1;
            return 0;
        },

        ordersCount(a, b) {
            let aActive = a.ordersNumber;
            let bActive = b.ordersNumber;
            if (aActive > bActive)
                return -1;
            if (aActive < bActive)
                return 1;
            return 0;
        },

    },
    created(){
        let _self = this;
        this.$topnavbar.$on('closeAddVehicle', () => {
            _self.openAddOrder = false;
        });
        this.$topnavbar.$on('successAddVehicle', () => {
            _self.openAddOrder = false;
            swal('Uspešno', 'Uspešno dodato vozilo', 'success')
            _self.getVehicles();
        });

    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')

    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                // this.pagination.page = 1;
                // this.getDrivers();
            }
        },
    }
}

function openAddUserModal() {
    this.openAddOrder = true;
}

function changedDateFrom() {

}


function changedDateTo() {

}

function getReport() {
    var _self = this;
    var calendarTimestampFrom = Date.parse(_self.fromDate);
    var calendarTimestampTo = Date.parse(_self.toDate);
    if(isNaN(calendarTimestampFrom)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }
    if(isNaN(calendarTimestampTo)){
        if(_self.isDateError == null){
            swal('Greška', 'Izaberite validan datum', 'error');
            _self.isDateError = 'notvalid'
        }

        return;
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {

    });
    // swal('Molimo sačekajte', 'Kreiranje izveštaja', 'warning');
    _self.isDateError = null;
    _self.dates = this.generateDates(calendarTimestampFrom, calendarTimestampTo)
    var date =  "?fromTimestamp=" + calendarTimestampFrom + "&toTimestamp="+calendarTimestampTo;
    AdminApiService.getSchedulesReport(date)
        .then((response) => {
            swal('Uspešno', 'Izveštaj uspešno kreiran', 'success');
            var newList = [];
            let mapForDoc = new Map();
            let rawData = response.data;
            let amount = {
                username: "Ukupno",
                lastName: "Ukupno",
                ordersPriceAmount: 0,
                averageByOrder: '',
                workingDays: '',
                ordersNumber: 0,
                workMinutes: 0,
                wage: 0,
                costs: 0,
                expense: 0,
                voucher: null
            }
            for (let i = 0; i < rawData.length; i++) {
                if(rawData[i].schedules.length !== 0){
                    for(let k =0; k< _self.dates.length; k++){
                        var obj = _self.hasScheduleByDate(rawData[i].schedules, _self.dates[k], rawData[i].lastName)
                        let key = _self.dates[k]
                        var data = mapForDoc.get(key)
                        if(data == null) mapForDoc.set(key, [])
                        if(obj != null){
                            mapForDoc.get(key).push(obj)
                        }
                    }
                }else {
                    for(let k = 0; k< _self.dates.length; k++){
                        let key = _self.dates[k]
                        var data = mapForDoc.get(key)
                        if(data == null){
                            mapForDoc.set(key, [])
                            // mapForDoc.get(key).push({
                            //     name: rawData[i].lastName,
                            //     profit: 0
                            // })
                        }else{
                            // data.push({
                            //     name: rawData[i].lastName,
                            //     profit: 0
                            // })
                        }
                    }
                }

                var currentCalculation = this.generateOrderFromSchedule(rawData[i].schedules)

                var newModel = {
                    username: rawData[i].username,
                    lastName: rawData[i].lastName,
                    averageByOrder: currentCalculation.ordersNumber === 0 ? 0 : _self.calculateHoursNew(rawData[i].schedules) / currentCalculation.ordersNumber,
                    workingDays: rawData[i].schedules.length,
                    ordersPriceAmount: currentCalculation.ordersPriceAmount,
                    ordersNumber: currentCalculation.ordersNumber,
                    workMinutes: _self.calculateHoursNew(rawData[i].schedules),
                    wage: currentCalculation.totalWage,
                    costs: currentCalculation.totalCosts,
                    expense: currentCalculation.totalExpense,
                    // wage: _self.checkNull(rawData[i].totalWage),
                    // costs: _self.checkNull(rawData[i].totalCosts),
                    // expense: _self.checkNull(rawData[i].totalExpense),
                    voucher: recalculateVouchersNew(rawData[i].schedules)
                }
                amount.ordersPriceAmount =  amount.ordersPriceAmount + newModel.ordersPriceAmount;
                amount.ordersNumber =  amount.ordersNumber + newModel.ordersNumber;
                amount.workMinutes =  amount.workMinutes + newModel.workMinutes;
                amount.wage =  amount.wage + newModel.wage;
                amount.costs =  amount.costs + newModel.costs;
                amount.expense =  amount.expense + newModel.expense;
                amount.voucher = _self.mergeVouchers(amount.voucher, newModel.voucher)
                newList.push(newModel);
            }
            newList.sort((a,b) => _self.ordersCount(a,b))
            newList.push(amount)
            _self.schedulesForDoc = mapForDoc;
            _self.schedules =  newList;

        })
        .catch((error) => {
            console.error(error)
            swal('Greška', error.data.message, 'error')
        })
}

function generateOrderFromSchedule(schedules){
    var model = {
        ordersNumber: 0,
        ordersPriceAmount: 0,
        totalWage: 0,
        totalCosts: 0,
        totalExpense: 0
    }
    for(var i = 0; i< schedules.length; i++){
        model.ordersNumber = model.ordersNumber + schedules[i].orders.length
        model.ordersPriceAmount = model.ordersPriceAmount + this.sumOrdersPrice(schedules[i].orders)
        model.totalWage = model.totalWage + schedules[i].wage
        model.totalCosts = model.totalCosts + schedules[i].costs
        model.totalExpense = model.totalExpense + schedules[i].expense
    }

    return model;
}

function sumOrdersPrice(orders){
    var price = 0;
    for(var i = 0; i< orders.length; i++){
        price = price + orders[i].price;
    }
    return price
}

function hasScheduleByDate(schedules, date, user){
    var data = {
        name: user,
        startShift: "",
        profit: 0
    }
    for(let i = 0; i < schedules.length; i++){
        if(this.formatDate(schedules[i].timestamp) === date){
            let obj = schedules[i];
            var orderPriceAmount = 0;
            for(let j = 0; j < obj.orders.length; j++){
                orderPriceAmount = orderPriceAmount + obj.orders[j].price;
            }
            let p = round(orderPriceAmount - checkNull(obj.wage) - checkNull(obj.costs) - checkNull(obj.expense))
            if(p != null ){
                data.profit = data.profit + p;
            }
            data.startShift = this.convertStringShiftToDouble(obj.startShift);
            // if(p===0) return null
            // return {
            //     name: user,
            //     startShift: this.convertStringShiftToDouble(obj.startShift),
            //     profit: p
            // }
        }
    }
    if(data.profit === 0) return null
    return data
}

function convertStringShiftToDouble(shift){
    if(shift == null) return 100;
    try{
        var temp = shift.split(":")
        return parseFloat(temp[0]) + parseFloat(temp[1])/100.0
    }catch (e){
        return 100
    }
}

function generateDates(from, to){
    let _self = this;
    let HOUR_24 = 1000*60*60*24;
    var dates = [];
    var firstDate = from;
    while (firstDate <= to){
        dates.push(_self.formatDate(firstDate));
        firstDate = firstDate + HOUR_24;
    }
    return dates;
}

function mergeVouchers(currentVouchers, newVouchers){
    var i = 0;
    var allVouchers = "";
    if(currentVouchers != null){
        var cVouchers = currentVouchers.split(";")
        for(i = 0; i< cVouchers.length; i++){
            allVouchers += cVouchers[i]+ ";";
        }
    }
    if(newVouchers != null){
        var nVouchers = newVouchers.split(";")
        for(i = 0; i< nVouchers.length; i++){
            allVouchers += nVouchers[i] + ";";
        }
    }
    if(allVouchers.isEmpty) return null;
    var green = 0;
    var blue = 0;
    var white = 0;

    var tempVouchers = allVouchers.split(";");
    tempVouchers.forEach(e => {
        if(e.length > 0){
            var tempVoucher =  e.split("-");
            var v = {
                voucher: tempVoucher[0],
                count: parseInt(tempVoucher[1])
            }
            if(v.voucher === 'VOUCHER_GREEN') green+=v.count;
            if(v.voucher === 'VOUCHER_BLUE') blue+=v.count;
            if(v.voucher === 'VOUCHER_WHITE') white+=v.count;
        }
    });


    var returnValue = "";
    if(green > 0) returnValue += "VOUCHER_GREEN-"+green+";";
    if(blue > 0) returnValue += "VOUCHER_BLUE-"+blue+";";
    if(white > 0) returnValue += "VOUCHER_WHITE-"+white+";";

    if(returnValue.isEmpty){
        return null;
    }else{
        return returnValue;
    }
}

function recalculateVouchersNew(schedules) {
    var i = 0;
    var allVouchers = "";
    for(i = 0; i<schedules.length; i++){
        allVouchers += schedules[i].voucher;
    }
    if(allVouchers.isEmpty) return null;
    var green = 0;
    var blue = 0;
    var white = 0;

    var tempVouchers = allVouchers.split(";");
    tempVouchers.forEach(e => {
        if(e.length > 0){
            var tempVoucher =  e.split("-");
            var v = {
                voucher: tempVoucher[0],
                count: parseInt(tempVoucher[1])
            }
            if(v.voucher === 'VOUCHER_GREEN') green+=v.count;
            if(v.voucher === 'VOUCHER_BLUE') blue+=v.count;
            if(v.voucher === 'VOUCHER_WHITE') white+=v.count;
        }
    });


    var returnValue = "";
    if(green > 0) returnValue += "VOUCHER_GREEN-"+green+";";
    if(blue > 0) returnValue += "VOUCHER_BLUE-"+blue+";";
    if(white > 0) returnValue += "VOUCHER_WHITE-"+white+";";

    if(returnValue.isEmpty){
        return null;
    }else{
        return returnValue;
    }

}

function recalculateVouchers(currentVoucher, newVoucher) {
    var green = 0;
    var blue = 0;
    var white = 0;

    if(currentVoucher != null && currentVoucher.length > 0){
        var tempVouchers = currentVoucher.split(";");
        tempVouchers.forEach(e => {
            if(e.length > 0){
                var tempVoucher =  e.split("-");
                var v = {
                    voucher: tempVoucher[0],
                    count: parseInt(tempVoucher[1])
                }
                if(v.voucher === 'VOUCHER_GREEN') green+=v.count;
                if(v.voucher === 'VOUCHER_BLUE') blue+=v.count;
                if(v.voucher === 'VOUCHER_WHITE') white+=v.count;
            }
        });
    }

    if(newVoucher != null && newVoucher.length > 0){
        var tempVouchers2 = newVoucher.split(";");
        tempVouchers2.forEach(e => {
            if(e.length > 0){
                var tempVoucher2 =  e.split("-");
                var v = {
                    voucher: tempVoucher2[0],
                    count: parseInt(tempVoucher2[1])
                }
                if(v.voucher === 'VOUCHER_GREEN') green+=v.count;
                if(v.voucher === 'VOUCHER_BLUE') blue+=v.count;
                if(v.voucher === 'VOUCHER_WHITE') white+=v.count;
            }
        });
    }

    var returnValue = "";
    if(green > 0) returnValue += "VOUCHER_GREEN-"+green+";";
    if(blue > 0) returnValue += "VOUCHER_BLUE-"+blue+";";
    if(white > 0) returnValue += "VOUCHER_WHITE-"+white+";";

    if(returnValue.isEmpty){
        return null;
    }else{
        return returnValue;
    }
}


function keymonitor(event) {
    if (event.key === 'Enter') {
        this.getVehicles();
    }
}


function checkNull(data) {
    if(data == null) return 0;
    return data;
}


function round(num) {
    return Math.round((num + Number.EPSILON) * 100) / 100
}

function roundWhole(num){
    return Math.round(num)
}

function calculateHoursNew(schedules) {
    var i = 0;
    var amountMinutes = 0;
    for(i = 0; i<schedules.length; i++){
        amountMinutes += calculateHours(schedules[i]);
    }
    return amountMinutes;
}

function calculateHours(schedule) {
    if(schedule.startTime == null || schedule.completionTime == null) return 0;
    var minutes = (schedule.completionTime - schedule.startTime)/60000;
    return Math.floor(minutes)
}

function displayHoursAndMinutes(minutes) {
    var hours = Math.floor(minutes / 60);
    var minutes = minutes % 60;
    var displayHours=  "" + hours;
    var displayMinutes=  "" + minutes;
    if(hours < 10) displayHours = "0"+hours;
    if(minutes < 10) displayMinutes = "0"+minutes;
    return "" + displayHours + ":"+displayMinutes +""
}

function getVoucherStyle(voucher) {
    switch (voucher) {
        case 'VOUCHER_BLUE': return "width: 30px; height: 24px; background: cornflowerblue; margin-right: 5px; color: black;";
        case 'VOUCHER_GREEN': return "width: 30px; height: 24px; background: forestgreen; margin-right: 5px; color: black;";
        case 'VOUCHER_WHITE': return "width: 30px; height: 24px; background: lightgrey; color: black;";
        default : return "width: 0px; height: 0px;"
    }
}

function getVouchers(voucher) {
    var list = [];
    if(voucher.length === 0) return list;
    var tempVouchers = voucher.split(";");
    tempVouchers.forEach(e => {
        var tempVoucher =  e.split("-");
        if(tempVoucher.length === 2){
            list.push({
                voucher: tempVoucher[0],
                count: parseInt(tempVoucher[1])
            })
        }
    });

    return list;
}

function formatDate(date) {
    return this.$moment(new Date(date )).format('DD-MM-YYYY')
}

function generateExcelFile(isPDF){
    let _self = this;
    var courierSize = 0;

    // var courierSize = this.schedulesForDoc.get(_self.dates[0]).length;
    var csvFile = "";
    // var csvFile = "data:text/csv;charset=utf-8,\n";
    for(var i = 0; i < _self.dates.length; i++){
        var currentList = this.schedulesForDoc.get(_self.dates[i])
        currentList.sort((a,b) => _self.compareByTime(a,b));
        this.schedulesForDoc.set(_self.dates[i], currentList)
        var cSize = currentList.length
        if(cSize > courierSize){
            courierSize = cSize
        }
        csvFile = csvFile + _self.dates[i] + ", Zarada ,"
    }
    csvFile = csvFile + "\n";
    var amountMap = new Map();
    for(var k = 0; k < courierSize; k++){
        for(var j = 0; j < _self.dates.length; j++){
            var list = this.schedulesForDoc.get(_self.dates[j])
            var obj = list[k];

            if(obj == null || obj.profit === 0){
                csvFile = csvFile + "" + '' +","+'' +","
            }else{
                csvFile = csvFile + "" + obj.name +","+obj.profit.toFixed(2) +","
                if(amountMap.get(_self.dates[j]) == null){
                    amountMap.set(_self.dates[j], 0)
                }
                amountMap.set(_self.dates[j], amountMap.get(_self.dates[j]) + obj.profit);
            }

        }
        csvFile = csvFile + "\n";
    }
    for(var q = 0; q < _self.dates.length; q++){
        var amount = amountMap.get(_self.dates[q]) != null ? amountMap.get(_self.dates[q]) : 0;
        csvFile = csvFile + "Ukupno,"+amount.toFixed(2) +","
    }
    csvFile = csvFile + "\n";
    if(isPDF){
        this.generatePDFFile(csvFile)
        return;
    }
    // console.log(csvFile)
    // var encodedUri = encodeURI(csvFile);
    // window.open(encodedUri);
    var universalBOM = "\uFEFF";
    // var encodedUri = encodeURI(csvFile);
    var link = document.createElement("a");
    link.setAttribute("href", 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvFile));
    link.setAttribute("download", "izvestaj.csv");
    document.body.appendChild(link); // Required for FF
    link.click(); // This will download the data file nam
}

function generatePDFFile(csvFile){
    // var from = this.$moment(Date.parse(this.fromDate)).format('DD.MM.YYYY.')
    // var to = this.$moment(Date.parse(this.toDate)).format('DD.MM.YYYY.')
    console.log(csvFile)
    var temp = csvFile.split("\n");
    var mainBody = [];
    var widthRow = [];
    for(var i = 0; i < temp.length - 1; i++){
        var row = temp[i].split(",")
        var tempRow = [];
        if(widthRow.length === 0){
            for(var k = 0; k < row.length; k++){
                widthRow.push('auto')
            }
        }
        for(var j = 0; j < row.length; j++){
            tempRow.push({text: '' + row[j], style: 'mainRowTable'})

        }
        mainBody.push(tempRow);
    }

    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    var dd = {
        pageOrientation: 'landscape',
        content: [
            {
                style: 'tableExample',
                table: {
                    headerRows: 1,
                    widths: widthRow,//['auto', 'auto', 'auto', 'auto', 'auto','auto'],
                    body: mainBody
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        if(rowIndex === 0) return '#AAAAAA';
                        return (columnIndex % 2 === 0) ? '#CCCCCC' : null;
                    }
                }
                // layout: 'lightHorizontalLines'
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            headerRacun: {
                fontSize: 36,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            companyInfo: {
                fontSize: 9,
                margin: [0, 10, 0, 5]
            },
            mainHeaderTable: {
                fontSize: 10,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            mainRowTable: {
                fontSize: 7,
                margin: [0, 0, 0, 0],
            },
            miniHeaderTable: {
                fontSize: 8,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            miniRowTable: {
                fontSize: 8,
                margin: [0, 0, 0, 0]
            },

            miniHeaderTable2: {
                fontSize: 12,
                bold: true,
                margin: [0, 0, 0, 0]
            },
            miniRowTable2: {
                fontSize: 12,
                margin: [0, 0, 0, 0]
            },

            tableExample: {
                margin: [0, 5, 0, 15]
            },
            miniTableExample: {
                margin: [0, 2, 0, 2]
            },
            tableHeader: {
                bold: true,
                fontSize: 13,
                color: 'black'
            }
        },

    }
    var fileName = 'Izvestaj korisnika.pdf';
    pdfMake.createPdf(dd).download(fileName)
}


// WEBPACK FOOTER //
// ./src/components/Report/ScheduleReport.js